import { type EntityParty, type WorkItem } from "@digits-graphql/frontend/graphql-bearer"
import { useSupportingTransactions } from "src/frontend/components/OS/Shared/WorkItems/useSupportingTransactions"

export function useSupportingParties(workItem: WorkItem): {
  object?: EntityParty | null
  from?: EntityParty | null
  to?: EntityParty | null
  userProvided?: EntityParty | null
  responseBased?: EntityParty | null
} {
  const { object, from, to, responseBased, userProvided } = useSupportingTransactions(workItem)

  return {
    object: object?.party,
    from: from?.party,
    to: to?.party,
    responseBased: responseBased?.party,
    userProvided: userProvided?.party,
  }
}
